import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ApolloProvider } from '@apollo/client';
import client from '../apolloClient';
import { IntlProvider } from 'use-intl';
import es from '@/../dictionaries/es.json';
import en from '@/../dictionaries/en.json';
import { getLanguageFromPath } from '@/utils/language';

const locales = {
	es,
	en
};

const App: React.FC = () => {
	const location = useLocation();
	const [language, setLanguage] = useState(getLanguageFromPath(location.pathname));
	useEffect(() => {
		setLanguage(getLanguageFromPath(location.pathname));
	}, [location.pathname]);

	return (
		<ApolloProvider client={client}>
			<Toaster
				toastOptions={{
					className: '',
					style: {
						maxWidth: '100%'
					}
				}}
			/>
			<IntlProvider messages={locales[language]} locale={language}>
				<Outlet />
			</IntlProvider>
		</ApolloProvider>
	);
};
export default App;
